import { render, staticRenderFns } from "./aiChatNew.vue?vue&type=template&id=1637ccef&"
import script from "./aiChatNew.vue?vue&type=script&lang=js&"
export * from "./aiChatNew.vue?vue&type=script&lang=js&"
import style0 from "./aiChatNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports